import { createStore } from "vuex";
import servicesModule from "./modules/services.js";
import mapModule from "./modules/map.js";

export default createStore({
  state: {
    none: true,
    sidenav: false,
    sidecontent: false,
    isProductsActive: false,
  },
  getters: {
    getSideNav: (state) => state.sidenav,
    getIsProductsActive: (state) => {
      console.log("getIsProductsActive", state.isProductsActive);
      return state.isProductsActive;
    },
  },
  mutations: {
    setSideNav(state, payload) {
      state.sidenav = payload;
    },
    setIsProductsActive(state, payload) {
      state.isProductsActive = payload;
    },
  },
  actions: {},
  modules: { servicesModule, mapModule },
});
